module.exports = __webpack_public_path__ + "static/media/copy-code.9bee4cde.svg";